import React, { useEffect, useState } from "react"
import MysteryBackdrop from "./MysteryBackdrop"
import TerminalBackdrop from "./TerminalBackdrop"
import Spotlight from "./Spotlight"
import ServiceNotification from "./ServiceNotification"

const DeferredEffects: React.FC = () => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (typeof window === "undefined") return
    const w = window as unknown as {
      requestIdleCallback?: (
        cb: () => void,
        opts?: { timeout: number }
      ) => number
      cancelIdleCallback?: (handle: number) => void
    }
    let idleHandle: number | null = null
    let timeoutHandle: number | null = null

    const reveal = () => setReady(true)

    if (typeof w.requestIdleCallback === "function") {
      idleHandle = w.requestIdleCallback(reveal, { timeout: 1500 })
    } else {
      timeoutHandle = window.setTimeout(reveal, 600)
    }

    return () => {
      if (idleHandle != null && typeof w.cancelIdleCallback === "function") {
        w.cancelIdleCallback(idleHandle)
      }
      if (timeoutHandle != null) window.clearTimeout(timeoutHandle)
    }
  }, [])

  if (!ready) return null

  return (
    <>
      <MysteryBackdrop />
      <TerminalBackdrop />
      <Spotlight />
      <ServiceNotification />
    </>
  )
}

export default DeferredEffects
